import * as o from "react";
import r from "../lib/SSRBase.es.js";
import m from "../defs/MetaLogo.es.js";
const e = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(r, { ref: a, ...t, weights: m }));
e.displayName = "MetaLogoIcon";
const f = e;
export {
  f as MetaLogo,
  e as MetaLogoIcon
};
